<template lang="pug">
  .b-auth-footer
    span._copy &copy;&nbsp;TeRoom {{ (new Date).getFullYear() }}
    ._right
      FooterSupport._support(greyTitle)
</template>

<script>
import FooterSupport from '@/components/FooterSupport.vue';
import FooterEmail from '@/components/FooterEmail.vue';

export default {
  name: 'AuthFooter',
  props: {
    hideEmail: {
      type: Boolean,
      default: false,
    },
  },
  components: { FooterEmail, FooterSupport },
};
</script>

<style lang="scss" scoped>
.auth-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__copy {
    color: var(--color-middle-gray);
    font-size: 11px;
  }

  &__right {
    display: flex;
    align-items: center;
  }
  &__mail {
    margin-right: 20px;
  }
  &__support {
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    margin-bottom: 0;
    &-desc {
      color: var(--color-light-dark);
    }
  }

  @media (max-width: 768px) {
    &__mail {
      display: none;
    }

    &__support {
      margin-right: 0;
      margin-bottom: 24px;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column-reverse;
  }
}
</style>
